import { useEffect, useState } from 'react'

import { getCookie, setCookie } from '@shared/utils'

function useQuiz({ question, isVideoQuiz }) {
  const [quiz, setQuiz] = useState(question)
  const [selected, setSelected] = useState(isAnswered(quiz?._id))
  const isCorrect = quiz?.aAnswers?.find((a) => a?.isCorrect)?._id

  function addAnswer(optionId) {
    if (!selected) {
      const answer = getAllAnswer(quiz?.quizId)
      answer[quiz?._id] = optionId
      setCookie({
        cName: `quiz-${quiz?.quizId}`,
        cValue: JSON.stringify(answer),
        exDays: 10
      })
      setSelected(optionId)
      updateQuiz(optionId)
      onAnswerEvent(optionId)
      !isVideoQuiz && handleNextQuiz()
    }
  }

  function isAnswered(optionId) {
    const answer = getAllAnswer(quiz?.quizId)
    return answer?.[optionId]
  }

  function updateQuiz(optionId) {
    const q = quiz
    q.nTotalVote = q?.nTotalVote + 1
    q.aAnswers = q?.aAnswers?.map((a) => (a._id === optionId ? { ...a, nVote: a?.nVote + 1 } : a))
    setQuiz(q)
  }

  function getAllAnswer(_id) {
    const answer = getCookie(`quiz-${_id || quiz?.quizId}`) || '{}'
    return JSON.parse(answer)
  }

  function getPercentage(nVote) {
    return Math.trunc(quiz?.nTotalVote >= nVote ? (nVote * 100) / quiz?.nTotalVote : 0) || 0
    // return pollData?.nTotalVote >= nVote ? (nVote * 100) / pollData?.nTotalVote : 0
  }

  function onAnswerEvent(iOptionId) {
    const event = new CustomEvent(quiz?._id, {
      bubbles: true,
      detail: { iOptionId }
    })
    document.dispatchEvent(event)
  }

  function handleNextQuiz(_id) {
    const event = new CustomEvent(quiz?.quizId, {
      bubbles: true
      // detail: { iOptionId }
    })
    document.dispatchEvent(event)
  }

  function getCorrectClass(optionId) {
    if (isCorrect === optionId) return 'correct'
    else if (isCorrect !== optionId && selected === optionId) return 'inCorrect'
    return ''
  }

  useEffect(() => {
    setQuiz(question)
    setSelected(isAnswered(question?._id))
  }, [question])

  return {
    addAnswer,
    getPercentage,
    getAllAnswer,
    getCorrectClass,
    quiz,
    selected,
    isCorrect
  }
}
export default useQuiz
